import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Card, CardContent } from "@/components/ui/card";
import { User, Route, Webhook } from "lucide-react";

type AgentType = "project" | "routing" | "external";

type AgentTypeSelectionProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: AgentType) => void;
};

export const AgentTypeSelection = ({ isOpen, onClose, onSelectType }: AgentTypeSelectionProps) => {
  const handleTypeSelection = (type: AgentType) => {
    onSelectType(type);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Seleccionar tipo de agente</DialogTitle>
        </DialogHeader>

        <div className="pb-6">
          <div className="flex flex-col gap-6">
            <p className="text-lg text-center text-gray-600">
              Elige el tipo de agente que quieres crear
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Card
                className="cursor-pointer hover:-translate-y-1 hover:shadow-xl border-2 border-gray-200 bg-white transition-all duration-300"
                onClick={() => handleTypeSelection("project")}
              >
                <CardContent className="p-8">
                  <div className="flex flex-col items-center gap-4 text-center">
                    <div className="p-4 rounded-full bg-blue-50 text-blue-500">
                      <User className="w-8 h-8" />
                    </div>

                    <h3 className="text-xl font-bold text-blue-600">
                      Agente Comercial especializado en un Proyecto
                    </h3>

                    <p className="text-md text-gray-600 leading-relaxed">
                      Crea un agente especializado en un proyecto específico que podrá agendar citas
                      virtuales o presenciales para un proyecto en particular, también podrá
                      descartar prospectos que no estén interesados en el proyecto.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card
                className="cursor-pointer hover:-translate-y-1 hover:shadow-xl border-2 border-gray-200 bg-white transition-all duration-300"
                onClick={() => handleTypeSelection("routing")}
              >
                <CardContent className="p-8">
                  <div className="flex flex-col items-center gap-4 text-center">
                    <div className="p-4 rounded-full bg-orange-50 text-orange-500">
                      <Route className="w-8 h-8" />
                    </div>

                    <h3 className="text-xl font-bold text-orange-600">
                      Agente Comercial Enrutador
                    </h3>

                    <p className="text-md text-gray-600 leading-relaxed">
                      Crea un agente que reciba a los prospectos que escriban a la línea de whatsapp
                      sin que algún agente los haya contactado previamente (inbound). Este agente
                      podrá indagar sobre el proyecto de interés y asignar el prospecto a un agente
                      dedicado a ese proyecto.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card
                className="cursor-pointer hover:-translate-y-1 hover:shadow-xl border-2 border-gray-200 bg-white transition-all duration-300"
                onClick={() => handleTypeSelection("external")}
              >
                <CardContent className="p-8">
                  <div className="flex flex-col items-center gap-4 text-center">
                    <div className="p-4 rounded-full bg-green-50 text-green-500">
                      <Webhook className="w-8 h-8" />
                    </div>

                    <h3 className="text-xl font-bold text-green-600">
                      Agente Externo (Webhook)
                    </h3>

                    <p className="text-md text-gray-600 leading-relaxed">
                      Crea un agente que reenvíe los mensajes del cliente a un servicio externo
                      vía webhook HTTP. Los mensajes no pasan por LangGraph, se envían directamente
                      al URL configurado.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
